import { Auth } from "aws-amplify";
import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Button } from "semantic-ui-react";
import Modal from "@medasync/shared-ui/dist/Modal";
import { insurancePlanGroupPlanGroupIdDelete } from "./store/actions";

class DeleteInsurancePlanGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      shouldRedirect: false,
    };
  }

  doLink(path) {
    const { baseRoute = "" } = this.props;
    return `${baseRoute}${path}`;
  }

  openModal(open) {
    this.setState({ open });
  }

  deleteInsurancePlanGroup() {
    const { planGroupId } = this.props;
    Auth.currentAuthenticatedUser()
      .then(data =>
        insurancePlanGroupPlanGroupIdDelete(
          data.signInUserSession.idToken.jwtToken,
          planGroupId
        )
      )
      .then(data =>
        this.setState({
          ...this.state,
          shouldRedirect: true,
        })
      )
      .catch(err => Auth.signOut());
  }

  render() {
    const { shouldRedirect } = this.state;
    if (shouldRedirect) {
      return (
        <>
          <Redirect to={this.doLink("/insurance")} />
        </>
      );
    }

    return (
      <>
        <Button negative onClick={() => this.openModal(true)}>
          Delete
        </Button>
        <Modal
          open={this.state.open}
          onClose={() => this.openModal(false)}
          title="Delete Plan Group?"
        >
          <p>Are you sure?</p>
          <Button onClick={() => this.openModal(false)}>No</Button>
          <Button onClick={() => this.deleteInsurancePlanGroup()}>Yes</Button>
        </Modal>
      </>
    );
  }
}

export default connect(
  null,
  { insurancePlanGroupPlanGroupIdDelete }
)(DeleteInsurancePlanGroup);
